<template>
    <div class="dialog-wrapper">
        <div class="dialog-box">

            <div class="header"></div>

            <div class="dialog-inter" @click="$emit('inter')"></div>

            <div class="input-box-bg">
                <span class="input-box-off" :class="{'on': tipTotal}"></span>
                <input class="input-box" type="checkbox" v-model="tipTotal" @change="$emit('tip', tipTotal)"/>
                <span class="input-txt">当月不再提示</span>
            </div>

            <div class="dialog-close" @click="$emit('close')"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "GameDialog",

        data() {
            return {
                tipTotal: false,
            }
        },

        method: {
        }
    }
</script>


<style scoped lang="scss">
    .dialog-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        z-index: 100;

    }
    .dialog-box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        z-index: 101;
        border-radius: 30px;

    }
    .dialog-inter {
        position: absolute;
        bottom: 15px;
        width: 70%;
        left: 25%;
        height: 44px;
        background: url(../assets/game_inter.png) no-repeat;
        background-size: 70% 44px;
    }
    .dialog-close {
        position: absolute;
        bottom: -50px;
        width: 100%;
        left: 45%;
        height: 30px;
        background: url(../assets/close.png) no-repeat;
        background-size: 30px 30px;
    }

    .header {
        width: 290px;
        height: 315px;
        background: url("../assets/game_dialog.png") no-repeat;
        background-size: 290px 315px;
        margin-top: -130px;
    }

    .input-box-bg {
        position: absolute;
        bottom: 65px;
        width: 50%;
        left: 50%;

        .input-box {
            display: inline-block;
            position: absolute;
            opacity: 0;
            width: 20px;
            height: 20px;
            outline: none;
            -webkit-appearance: none;
            margin-top: -3px;
        }


        .input-box-off {
            width: 20px;
            height: 20px;
            vertical-align: middle;
            float: left;
            position: absolute;
            background: url(../assets/unchoose_white.png) no-repeat;
            background-size: 100% 100%;
            margin-top: -2px;
        }

        .on {
            background: url(../assets/choose_white.png) no-repeat;
            background-size: 100% 100%;
        }

        .input-txt {
            margin-left: 26px;
            font-size: 0.9rem;
            color: #ffffff;
            font-weight: bold;

        }
    }

    input:-webkit-autofill { background-color: transparent; }




</style>